import styled from 'styled-components';

export const StyledMachineRobotCleaningControls = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props): string => props.theme.kcc.spacing.SM};
  width: 100%;
`;

// Full-width row above the buttons; collapses when no alert is rendered.
export const StyledCleaningControlsAlert = styled.div`
  width: 100%;

  &:not(:empty) {
    margin-bottom: ${(props): string => props.theme.kcc.spacing.SM};
  }
`;
